module.exports = __webpack_public_path__ + "img/symbol_4.6ff92b83.png";